module.exports = __webpack_public_path__ + "9779d9a1/img/document.e2130c6b.svg";